import React, { useState, useEffect } from "react";
import { Images } from "../Common/Images";
import { setLanguage, getLanguage } from "../../utils/SecurityService";
import { useTranslation } from "react-i18next";

const languages = [
    { code: "en", flagName: "English", imageName: "united-kingdom", src: Images.UnitedKingdom },
    { code: "fr", flagName: "Français", imageName: "france", src: Images.France },
    { code: "es", flagName: "Español", imageName: "spain", src: Images.Spain },
    { code: "de", flagName: "Deutsch", imageName: "germany", src: Images.Germany },
    { code: "nl", flagName: "Nederlands", imageName: "netherlands", src: Images.Netherlands },
    { code: "it", flagName: "Italiano", imageName: "italy", src: Images.Italy },
    { code: "cs", flagName: "Čeština", imageName: "czech-republic", src: Images.CzechRepublic },
    { code: "pl", flagName: "Polski", imageName: "poland", src: Images.Poland },
    { code: "pt", flagName: "Português", imageName: "portugal", src: Images.Portugal }
];

const defaultLang = languages[0];

const normalizeLanguageCode = (lang) => {
    const normalized = String(lang || "").toLowerCase();
    const languageMap = {
        en: "en",
        fr: "fr",
        es: "es",
        de: "de",
        nl: "nl",
        it: "it",
        cz: "cs",
        cs: "cs",
        pl: "pl",
        pt: "pt"
    };

    return languageMap[normalized] || "";
};

const findLanguageByCode = (code) =>
    languages.find((lang) => lang.code === normalizeLanguageCode(code)) || null;

const getLanguageFromUrl = () => {
    if (typeof window === "undefined") return null;

    const params = new URLSearchParams(window.location.search);
    return findLanguageByCode(params.get("lang"));
};

function LanguageDropdown() {

    const { i18n } = useTranslation("common");

    const [selectedLang, setSelectedLang] = useState(() => {
        try {
            const urlLang = getLanguageFromUrl();
            if (urlLang) {
                return urlLang;
            }

            const stored = getLanguage();
            if (stored) {
                const parsed = JSON.parse(stored);
                return findLanguageByCode(parsed?.code) || defaultLang;
            }

            return defaultLang;
        } catch {
            return defaultLang;
        }
    });

    useEffect(() => {
        const urlLang = getLanguageFromUrl();
        if (urlLang && urlLang.code !== selectedLang.code) {
            setSelectedLang(urlLang);
        }
    }, [selectedLang.code]);

    useEffect(() => {
        setLanguage(JSON.stringify(selectedLang));
        i18n.changeLanguage(selectedLang.code);
    }, [selectedLang, i18n]);

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="dropdown-alignment">
            <div id="language-dropdown-container" className="language-dropdown-container">

                <button
                    className={`btn btn-secondary dropdown-toggle language-dropdown ${isOpen ? "show" : ""}`}
                    type="button"
                    id="language-dropdown"
                    data-bs-toggle="dropdown"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <div className="button-inner">
                        <img src={selectedLang.src} alt={selectedLang.flagName} />
                        <span>{selectedLang.flagName}</span>
                    </div>
                </button>

                <ul className={`dropdown-menu ${isOpen ? "show" : ""}`}>
                    <div className="dropdown-inner">
                        {languages.map((lang) => (
                            <li
                                key={lang.code}
                                className={selectedLang.code === lang.code ? "selected" : ""}
                                onClick={() => {
                                    const url = new URL(window.location.href);
                                    url.searchParams.set("lang", lang.code);
                                    window.history.replaceState(null, "", url);
                                    setSelectedLang(lang);
                                    setIsOpen(false);
                                    window.location.reload();
                                }}
                            >
                                <a
                                    className="dropdown-item"
                                    href="#!"
                                    onClick={(e) => e.preventDefault()}
                                >
                                    <img src={lang.src} alt={lang.flagName} />
                                    <span>{lang.flagName}</span>
                                </a>
                            </li>
                        ))}
                    </div>
                </ul>

            </div>
        </div>
    );
}

export default LanguageDropdown;
